import * as React from "react";
import { useState } from "react";
import { Form, Formik } from "formik";
import { Alert, Button, Modal } from "components/bootstrap";
import { ModalSubmit, Spinner } from "components/common";
import S3CredentialsFormFields, {
  validateS3CredentialsForm
} from "./S3CredentialsFormFields";
import useRepositoryCredentials from "./hooks/useRepositoryCredentials";
const initialFormValues = (record) => {
  var _a, _b, _c, _d, _e, _f;
  return record ? {
    auth_mode: record.auth_mode,
    aws_access_key_id: (_a = record.aws_access_key_id) != null ? _a : void 0,
    aws_secret_access_key: ((_b = record.aws_secret_access_key) == null ? void 0 : _b.is_set) ? { keep_value: true } : void 0,
    aws_region: (_c = record.aws_region) != null ? _c : void 0,
    endpoint_uri: (_d = record.endpoint_uri) != null ? _d : void 0,
    aws_assume_role_arn: (_e = record.aws_assume_role_arn) != null ? _e : void 0,
    aws_external_id: (_f = record.aws_external_id) != null ? _f : void 0
  } : { auth_mode: "key_secret" };
};
const toUpdatePayload = (values) => {
  var _a, _b, _c, _d;
  return {
    auth_mode: values.auth_mode,
    aws_access_key_id: values.auth_mode === "key_secret" && values.aws_access_key_id || null,
    aws_secret_access_key: values.auth_mode === "key_secret" ? values.aws_secret_access_key : void 0,
    aws_region: (_a = values.aws_region) != null ? _a : null,
    endpoint_uri: (_b = values.endpoint_uri) != null ? _b : null,
    aws_assume_role_arn: (_c = values.aws_assume_role_arn) != null ? _c : null,
    aws_external_id: (_d = values.aws_external_id) != null ? _d : null
  };
};
const EditCredentialsModal = ({ repositoryName, onClose }) => {
  const { credentials, onUpdateCredentials } = useRepositoryCredentials(repositoryName);
  const [verificationError, setVerificationError] = useState(null);
  const handleSubmit = (values, { setErrors }) => {
    setVerificationError(null);
    return onUpdateCredentials(toUpdatePayload(values)).then(() => onClose()).catch((error) => {
      var _a, _b;
      const body = (_a = error == null ? void 0 : error.additional) == null ? void 0 : _a.body;
      if ((error == null ? void 0 : error.status) === 400 && (body == null ? void 0 : body.failed) && (body == null ? void 0 : body.errors)) {
        const { verification, ...fieldErrors } = body.errors;
        setErrors(
          Object.fromEntries(Object.entries(fieldErrors).map(([field, messages]) => [field, messages.join(" ")]))
        );
        if (verification) {
          setVerificationError(verification.join(" "));
        }
      } else {
        setVerificationError((_b = body == null ? void 0 : body.message) != null ? _b : String(error));
      }
    });
  };
  const modalContent = () => {
    var _a, _b, _c, _d, _e;
    if (credentials.isLoading) {
      return /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(Spinner, { text: "Loading repository credentials..." }));
    }
    if (credentials.error) {
      const body = (_b = (_a = credentials.error) == null ? void 0 : _a.additional) == null ? void 0 : _b.body;
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: "Could not load repository credentials" }, (_c = body == null ? void 0 : body.message) != null ? _c : String(credentials.error))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(Button, { onClick: onClose }, "Close")));
    }
    const record = (_d = credentials.data) != null ? _d : null;
    const secretIsSet = !!((_e = record == null ? void 0 : record.aws_secret_access_key) == null ? void 0 : _e.is_set);
    return /* @__PURE__ */ React.createElement(
      Formik,
      {
        initialValues: initialFormValues(record),
        validate: validateS3CredentialsForm,
        onSubmit: handleSubmit
      },
      ({ isSubmitting, isValidating, isValid }) => /* @__PURE__ */ React.createElement(Form, { className: "form form-horizontal" }, /* @__PURE__ */ React.createElement(Modal.Body, null, verificationError && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: "Credential verification failed" }, verificationError), /* @__PURE__ */ React.createElement(S3CredentialsFormFields, { secretIsSet })), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
        ModalSubmit,
        {
          submitButtonText: "Save",
          submitLoadingText: "Verifying...",
          onCancel: onClose,
          disabledSubmit: isValidating || !isValid,
          isSubmitting
        }
      )))
    );
  };
  return /* @__PURE__ */ React.createElement(Modal, { show: true, bsSize: "large", onHide: onClose }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, 'Edit credentials of repository "', repositoryName, '"')), modalContent());
};
export default EditCredentialsModal;
